import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { EmailTypesDirective, EmailTypesComponent, EmailTypeComponent, EmailTypeDirective, EmailLogsComponent, EmailLogsDirective, EmailTemplateComponent, EmailTemplateDirective } from './email-types.directive';
import { BulkActionsDirective, BulkActionsComponent, BulkActionCreateOrEditDirective, BulkActionCreateOrEditComponent, BulkActionViewDirective, BulkActionViewComponent } from './bulk-actions.directive';
import { MainTemplateComponent, MainTemplateDirective, TwoColumnsRightComponent, TwoColumnsRightDirective } from './main.template.directive';
import { ActivityComponent, ActivityDirective, DashboardComponent, DashboardDirective, SummaryComponent, SummaryDirective } from './dashboard.directive';
import { FaqsListComponent, FaqsListDirective, FaqFormComponent, FaqFormDirective } from './faqs.directive';
import { SettingsComponent, SettingsDirective, ReviewComponent, ReviewDirective, StatusComponent, StatusDirective, OfflineSettingsDirective, OfflineSettingsComponent, OfflineTestDirective, OfflineTestComponent } from './settings.directive';
import { RouterModule } from '@angular/router';
import {
  EventTypesListComponent,
  EventTypesListDirective,
  EventTypeFormComponent,
  EventTypeFormDirective,
  EventTypePreviewComponent,
  EventTypePreviewDirective,
  EventTypeSectionComponent,
  EventTypeSectionDirective,
  EventTypeSectionFieldComponent,
  EventTypeSectionFieldDirective,
  EventTypeSectionPredefinedFieldsComponent,
  EventTypeSectionPredefinedFieldsDirective
} from './event-types.directive';
import {
  BlueprintsListComponent,
  BlueprintsListDirective,
  BlueprintFormComponent,
  BlueprintFormDirective,
  BlueprintMapsListComponent,
  BlueprintMapsListDirective,
  BlueprintMapEditComponent,
  BlueprintMapEditDirective,
  BlueprintMapMappingComponent,
  BlueprintMapMappingDirective
} from './blueprints.directive';
import {
  AnnouncementsListComponent,
  AnnouncementsListDirective,
  AnnouncementFormComponent,
  AnnouncementFormDirective,
  AnnouncementsReorderComponent,
  AnnouncementsReorderDirective,
  InboxDirective,
  InboxComponent,
  InboxMessageDirective,
  InboxMessageComponent
} from './announcements.directive';
import {
  DashboardTemplatesListComponent,
  DashboardTemplatesListDirective,
  DashboardTemplateFormComponent,
  DashboardTemplateFormDirective,
  DashboardTemplatesReorderComponent,
  DashboardTemplatesReorderDirective
} from './dashboard-templates.directive';
import {
  ProfileTemplatesListComponent,
  ProfileTemplatesListDirective,
  ProfileTemplateFormComponent,
  ProfileTemplateFormDirective
} from './profile-templates.directive';
import {
  OrgChooserComponent,
  OrgChooserDirective
} from './accounts.directive';
import {
  FilesListComponent,
  FilesListDirective
} from './files.directive';
import {
  RelationsListComponent,
  RelationsListDirective,
  RelationFormComponent,
  RelationFormDirective,
  RelationsReorderComponent,
  RelationsReorderDirective
} from './relations.directive';
import { RoleFormComponent, RoleFormDirective, RolesListComponent, RolesListDirective } from './roles.directive';
import {
  UserFieldsListComponent,
  UserFieldsListDirective,
  UserFieldFormComponent,
  UserFieldFormDirective,
  UserFieldsReorderComponent,
  UserFieldsReorderDirective
} from './user-fields.directive';
import {
  OrganisationsListComponent,
  OrganisationsListDirective,
  OrganisationFormComponent,
  OrganisationFormDirective,
  OrganisationSettingsComponent,
  OrganisationSettingsDirective,
  OrganisationControlPanelComponent,
  OrganisationControlPanelDirective
} from './organisations.directive';
import { PendingSectionsComponent, PendingSectionsDirective } from './admin.directive';
import { AllEventsComponent, AllEventsDirective, ApplyTagsComponent, ApplyTagsDirective, EventsComponent, EventsDirective, EventSectionComponent, EventSectionDirective, EventSectionViewComponent, EventSectionViewDirective, EventViewComponent, EventViewDirective, ManageTimelinesComponent, ManageTimelinesDirective, NewEventComponent, NewEventDirective, SelectTagsComponent, SelectTagsDirective, TearoffEventViewComponent, TearoffEventViewDirective } from './events.directive';
import { UserCreateComponent, UserCreateDirective, UserEditComponent, UserEditDirective, UserEventsComponent, UserEventsDirective, UsersListComponent, UsersListDirective, UserViewComponent, UserViewDirective } from './users.directive';
import { ReportTemplatesComponent, ReportTemplatesDirective, ReportRunComponent, ReportRunDirective, ReportTemplateFormComponent, ReportTemplateFormDirective, MultiReportEditElementDirective, MultiReportEditElementComponent, ReportWrapperDirective, ReportWrapperComponent } from './reports.directive';
import { GoalsListComponent, GoalsListDirective, GoalViewComponent, GoalViewDirective, GoalEditComponent, GoalEditDirective, TargetsLinkDirective, TargetsLinkComponent, UserGoalsDirective, UserGoalsComponent, ManageCategoriesDirective, ManageCategoriesComponent } from './goals.directive';

@NgModule({
    imports: [RouterModule],
    providers: [],
    declarations: [
        DashboardDirective,
        DashboardComponent,
        SummaryDirective,
        SummaryComponent,
        ActivityDirective,
        ActivityComponent,
        SettingsDirective,
        SettingsComponent,
        ReviewDirective,
        ReviewComponent,
        StatusDirective,
        StatusComponent,
        OfflineSettingsDirective,
        OfflineSettingsComponent,
        OfflineTestDirective,
        OfflineTestComponent,
        EmailTypesDirective,
        EmailTypesComponent,
        EmailTypeComponent,
        EmailTypeDirective,
        EmailLogsComponent,
        EmailLogsDirective,
        EmailTemplateComponent,
        EmailTemplateDirective,
        OrgChooserComponent,
        OrgChooserDirective,
        FilesListComponent,
        FilesListDirective,
        RelationsListComponent,
        RelationsListDirective,
        RelationFormComponent,
        RelationFormDirective,
        RelationsReorderComponent,
        RelationsReorderDirective,
        BulkActionsDirective,
        BulkActionsComponent,
        BulkActionCreateOrEditDirective,
        BulkActionCreateOrEditComponent,
        BulkActionViewDirective,
        BulkActionViewComponent,
        MainTemplateComponent,
        MainTemplateDirective,
        TwoColumnsRightComponent,
        TwoColumnsRightDirective,
        FaqsListDirective,
        FaqsListComponent,
        FaqFormDirective,
        FaqFormComponent,
        EventTypesListDirective,
        EventTypesListComponent,
        EventTypeFormDirective,
        EventTypeFormComponent,
        EventTypePreviewDirective,
        EventTypePreviewComponent,
        EventTypeSectionDirective,
        EventTypeSectionComponent,
        EventTypeSectionFieldDirective,
        EventTypeSectionFieldComponent,
        EventTypeSectionPredefinedFieldsDirective,
        EventTypeSectionPredefinedFieldsComponent,
        BlueprintsListDirective,
        BlueprintsListComponent,
        BlueprintFormDirective,
        BlueprintFormComponent,
        BlueprintMapsListDirective,
        BlueprintMapsListComponent,
        BlueprintMapEditDirective,
        BlueprintMapEditComponent,
        BlueprintMapMappingDirective,
        BlueprintMapMappingComponent,
        AnnouncementsListDirective,
        AnnouncementsListComponent,
        AnnouncementFormDirective,
        AnnouncementFormComponent,
        AnnouncementsReorderDirective,
        AnnouncementsReorderComponent,
        InboxDirective,
        InboxComponent,
        InboxMessageDirective,
        InboxMessageComponent,
        DashboardTemplatesListDirective,
        DashboardTemplatesListComponent,
        DashboardTemplateFormDirective,
        DashboardTemplateFormComponent,
        DashboardTemplatesReorderDirective,
        DashboardTemplatesReorderComponent,
        ProfileTemplatesListDirective,
        ProfileTemplatesListComponent,
        ProfileTemplateFormDirective,
        ProfileTemplateFormComponent,
        RolesListComponent,
        RoleFormComponent,
        RolesListDirective,
        RoleFormDirective,
        UserFieldsListComponent,
        UserFieldsListDirective,
        UserFieldFormComponent,
        UserFieldFormDirective,
        UserFieldsReorderComponent,
        UserFieldsReorderDirective,
        OrganisationsListComponent,
        OrganisationsListDirective,
        OrganisationFormComponent,
        OrganisationFormDirective,
        OrganisationSettingsComponent,
        OrganisationSettingsDirective,
        OrganisationControlPanelComponent,
        OrganisationControlPanelDirective,
        PendingSectionsDirective,
        PendingSectionsComponent,
        EventsDirective,
        EventsComponent,
        EventViewDirective,
        EventViewComponent,
        TearoffEventViewDirective,
        TearoffEventViewComponent,
        ManageTimelinesDirective,
        ManageTimelinesComponent,
        NewEventDirective,
        NewEventComponent,
        EventSectionDirective,
        EventSectionComponent,
        EventSectionViewDirective,
        EventSectionViewComponent,
        SelectTagsDirective,
        SelectTagsComponent,
        ApplyTagsDirective,
        ApplyTagsComponent,
        AllEventsDirective,
        AllEventsComponent,
        UserViewDirective,
        UserViewComponent,
        UserEditDirective,
        UserEditComponent,
        UsersListDirective,
        UsersListComponent,
        UserCreateDirective,
        UserCreateComponent,
        UserEventsDirective,
        UserEventsComponent,
        ReportTemplatesDirective,
        ReportTemplatesComponent,
        ReportRunDirective,
        ReportRunComponent,
        ReportTemplateFormDirective,
        ReportTemplateFormComponent,
        MultiReportEditElementDirective,
        MultiReportEditElementComponent,
        GoalsListDirective,
        GoalsListComponent,
        UserGoalsDirective,
        UserGoalsComponent,
        ManageCategoriesDirective,
        ManageCategoriesComponent,
        GoalViewDirective,
        GoalViewComponent,
        GoalEditDirective,
        GoalEditComponent,
        TargetsLinkDirective,
        TargetsLinkComponent,
        ReportWrapperDirective,
        ReportWrapperComponent,
    ],
    exports: [
        EmailTypesDirective,
        EmailTypesComponent,
        EmailTypeComponent,
        EmailLogsComponent,
        EventsDirective,
        OrgChooserComponent,
        BulkActionsComponent,
        BulkActionCreateOrEditComponent,
        BulkActionViewComponent,
        MainTemplateComponent,
        MainTemplateDirective,
        DashboardDirective,
        DashboardComponent,
        SummaryDirective,
        SummaryComponent,
        ActivityComponent,
        SettingsComponent,
        SettingsDirective,
        ReviewComponent,
        StatusComponent,
        FaqsListComponent,
        FaqFormComponent,
        EventTypesListComponent,
        EventTypeFormComponent,
        EventTypePreviewComponent,
        EventTypeSectionComponent,
        EventTypeSectionFieldComponent,
        EventTypeSectionPredefinedFieldsComponent,
        BlueprintsListComponent,
        BlueprintFormComponent,
        BlueprintMapsListComponent,
        BlueprintMapEditComponent,
        BlueprintMapMappingComponent,
        AnnouncementsListComponent,
        AnnouncementFormComponent,
        AnnouncementsReorderComponent,
        DashboardTemplatesListComponent,
        DashboardTemplateFormComponent,
        DashboardTemplatesReorderComponent,
        ProfileTemplatesListComponent,
        ProfileTemplateFormComponent,
        RelationsListComponent,
        RelationFormComponent,
        RelationsReorderComponent,
        RolesListComponent,
        RoleFormComponent,
        UserFieldsListComponent,
        UserFieldFormComponent,
        UserFieldsReorderComponent,
        OrganisationsListComponent,
        OrganisationFormComponent,
        OrganisationSettingsComponent,
        OrganisationControlPanelComponent,
        ],
    schemas: [NO_ERRORS_SCHEMA]
})
export class UpgradedModule { }
